import { Enumeration } from './enumeration.model';

export class EmailType extends Enumeration {
  static Native = new EmailType('852c8815-bbbb-45d5-8ab6-938d05cd9a69', 'Native');
  static EmailBody = new EmailType('862c8815-bbbb-45d5-8ab6-938d05cd9a69', 'EmailBody');
  static EmailAttachment = new EmailType('872c8815-bbbb-45d5-8ab6-938d05cd9a69', 'EmailAttachment');

  constructor(value: string, displayName: string) {
    super(value, displayName);
  }
}
